var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocumentDelite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 12C18.25 12.4142 18.5858 12.75 19 12.75C19.4142 12.75 19.75 12.4142 19.75 12H18.25ZM12 22.75C12.4142 22.75 12.75 22.4142 12.75 22C12.75 21.5858 12.4142 21.25 12 21.25V22.75ZM18.5364 7.44373L19.1126 6.96359L18.5364 7.44373ZM3.75 18V6H2.25V18H3.75ZM7 2.75H11V1.25H7V2.75ZM11 2.75H13.0633V1.25H11V2.75ZM18.25 8.7241V12H19.75V8.7241H18.25ZM14.0235 3.19977L17.9603 7.92387L19.1126 6.96359L15.1759 2.23949L14.0235 3.19977ZM12 21.25H7V22.75H12V21.25ZM13.0633 2.75C13.4342 2.75 13.786 2.91478 14.0235 3.19977L15.1759 2.23949C14.6534 1.61251 13.8794 1.25 13.0633 1.25V2.75ZM2.25 18C2.25 20.6234 4.37665 22.75 7 22.75V21.25C5.20507 21.25 3.75 19.7949 3.75 18H2.25ZM19.75 8.7241C19.75 8.08077 19.5245 7.45781 19.1126 6.96359L17.9603 7.92387C18.1475 8.14851 18.25 8.43168 18.25 8.7241H19.75ZM3.75 6C3.75 4.20507 5.20507 2.75 7 2.75V1.25C4.37665 1.25 2.25 3.37665 2.25 6H3.75Z",
    fill: "#717171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19H22",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5V6C14 7.10457 14.8954 8 16 8H18.5",
    stroke: "#717171",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentDelite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document-delite.6c7230a5f210fa90c5ef9891cd83bc31.svg";